import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";
import ModalLoading from "../sections/ModalLoading";
import Icon from "../sections/MUI/Icon";

class Contact extends Component {

    state = {
        contact: "",
        list: [],

        loading: true
    };


    componentDidMount() {
        this.props.setTitle("تماس با ما");
        req.getRequest(`${config.api}/user/contact`)
            .then(r => {
                this.setState({
                    contact: r.contact,
                    list: r.list,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    loading: false
                });
            });
    }

    render() {
        let {loading, contact, list} = this.state;
        return (
            <div className="contact">
                <ModalLoading loading={loading}/>
                <pre>{contact}</pre>
                {
                    list.length > 0 ?
                        list.map((c, i) =>
                            <div className="contact-item"
                                 onClick={() => {
                                     try {
                                         if (window) {
                                             window.open(`tel:${c}`, "_blank")
                                         } else if (document) {
                                             document.location.href = `tel:${c}`;
                                         }
                                     } catch (err) {
                                     }
                                 }}
                                 key={"contact" + i}><span>{c}</span><Icon i="phone"/></div>
                        )
                        : null
                }
            </div>
        );
    }
}

export default gpn(Contact);